// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"00260948","639":"25905dfa","855":"edc204ce"}[chunkId] + ".chunk.css";
};